import { render } from "./IconFolderPlus.vue?vue&type=template&id=4e1cc7f9"
const script = {}
script.render = render

export default script